<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_EMBARGOS"/>
          EMBARGOS
        </span>
        <g-master name="lawsuits"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  modalWidth="80%"
                  @handleOk="handleOk"
                  :useMultipart="true"
                  ref="master"
                  @action="masterAction"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
        <div v-if="text ==='INACTIVO'">
          <a-tag color="red">{{text}}</a-tag>
        </div>
        <div v-if="text ==='ACTIVO'">
          <a-tag color="blue">{{text}}</a-tag>
        </div>
        <div v-if="text ==='PENDIENTE'">
          <a-tag color="purple">{{text}}</a-tag>
        </div>
      </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-tabs :active-key="numberAction" @change="changeTab">
              <a-tab-pane key="1" force-render>
                <span slot="tab">
                  <a-icon type="alert"/>
                  Datos obligatorios
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Empleado')"
                              :formItemConfig="fiOptions"
                              ref="empleado"
                              endpoint="empleados_en_reqliquidacion"
                              :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown v-bind="fiOptions"
                                endpoint="hierarchy_lookup"
                                :label="$t('Estado')"
                                :formItemConfig="fiOptions"
                                :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'A' }]"
                                :params="status">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Fecha de embargo')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD HH:mm:ss"
                                     v-decorator="['date_lawsuit', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Tipo de embargo')"
                                :formItemConfig="fiOptions"
                                endpoint="groups"
                                :decorator="['lawsuit_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                :params="{filtro_embargos: true}">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Grupo')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['id_groups', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                :params="grupo">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Proceso')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                ref="proceso"
                                :decorator="['prc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                :params="proceso">
                    </g-dropdown>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" force-render>
                <span slot="tab">
                  <a-icon type="pushpin"/>
                  Datos judiciales
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Número de expediente')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['num_file', {rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown v-if="office_consec" v-bind="fiOptions"
                                endpoint="hierarchy_lookup"
                                :label="$t('Of. Consec')"
                                :formItemConfig="fiOptions"
                                :params="office_consec_params"
                                :decorator="['office_consec', { rules: [{ required: false}] }]">
                    </g-dropdown>
                    <a-form-item v-else v-bind="fiOptions" :label="$t('Of. Consec')">
                      <a-input v-bind="fiOptions"
                               style="width: 100%"
                               v-decorator="['office_consec', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>

                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Número de proceso')">
                      <a-input v-bind="fiOptions"
                               style="width: 100%"
                               v-decorator="['process_number', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Código de juzgado')"
                              :formItemConfig="fiOptions"
                              ref="juzgado"
                              endpoint="courts_type"
                              :selectedObj.sync="cod_court"
                              :decorator="['cod_court', { rules: [{ required: false}] }]">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown v-bind="fiOptions"
                                endpoint="bank"
                                :label="$t('Banco')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_bank', { rules: [{ required: false}] }]">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Clase depósito')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['id_h_class_dep', { rules: [{ required: false}] }]"
                                :params="deposito">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Oficina origen')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              ref="oforigen"
                              :decorator="['id_h_office_orig', { rules: [{ required: false}] }]"
                              :params="oficinas">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Oficina destino')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              ref="ofdestino"
                              :decorator="['id_h_office_dest', { rules: [{ required: false}] }]"
                              :params="oficinas">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Número de cuenta')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['account_number', {rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="3" force-render>
                <span slot="tab">
                  <a-icon type="container"/>
                  Información del demandante
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Tipo de demandante')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['id_h_demandant_type', { rules: [{ required: false }] }]"
                                :params="tipo_demandante">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('ID del demandante')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['id_demandant', {rules: [{ required: false  }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Nombre del demandante')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['name_deman', { rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Primer apellido')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['last_name1_deman', { rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Segundo apellido')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['last_name2_deman', { rules: [{ required: false  }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="4" force-render>
                <span slot="tab">
                  <a-icon type="gold"/>
                  Valores del embargo
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Quinta parte')" v-bind="fiOptions">
                      <a-select v-model="fifth_part">
                        <a-select-option v-for="sn_ in listSN" :key="sn_.value">
                          {{ sn_.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Porcentaje')">
                      <a-input-number v-bind="fiOptions"
                                      style="width: 100%"
                                      v-decorator="['percentage', { rules: [{ required: false, message: 'Valor requerido' },
                              { validator: validatePercentage }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Valor fijo')">
                      <a-input-number
                        style="width: 100%"
                        v-decorator="['ammount_fixed', { rules: [{ required: false  }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Monto inicial')">
                      <a-input-number
                        style="width: 100%"
                        v-decorator="['amount_initial', { rules: [{ required: false  }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Balance')">
                      <a-input
                        style="width: 100%"
                        v-decorator="['balance', { rules: [{ required: false  }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Observaciones')">
                      <a-textarea placeholder=""
                                  autoSize
                                  v-decorator="['observation', { rules: [{ required: false  }] }]">
                      </a-textarea>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Subir archivo')">
                      <a-upload
                        name="profile_file"
                        :before-upload="beforeUpload"
                        :fileList="master.uploads.profileFile"
                        :remove="() => { master.uploads.profileFile = [] }">
                        <a-button style="width: 100%">Seleccionar archivo</a-button>
                      </a-upload>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Detalles" key="1">
          <lawsuits-details v-if="detalleEmbargo" :lawsuits_info="detalleEmbargo"></lawsuits-details>
          <span v-else>Seleccione para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '../../../../../util/JsUtils'

  const NEW_COLUMNS = [
    {title: 'Número de cuenta', dataIndex: 'account_number'},
    {title: 'Número expediente', dataIndex: 'num_file'},
    {title: 'Código juzgado', dataIndex: 'cod_court'},
    {title: 'ID del banco', dataIndex: 'id_h_bank'},
    {title: 'Nombre del banco', dataIndex: 'nombre_banco'},
    {title: 'Clase de depósito', dataIndex: 'id_h_class_dep'},
    {title: 'Oficina de origen', dataIndex: 'oficina_origen'},
    {title: 'Oficina de destino', dataIndex: 'oficina_destino'},
    {title: 'Tipo de demandante', dataIndex: 'tipo_demanda'},
    {title: 'ID del demandante', dataIndex: 'id_demandant'},
    {title: 'Nombre del demandante', dataIndex: 'name_deman'},
    {title: 'Primer apellido', dataIndex: 'last_name1_deman'},
    {title: 'Segundo apellido', dataIndex: 'last_name2_deman'},
    {title: 'Quinta parte', dataIndex: 'quinta_parte'},
    {title: 'Porcentaje', dataIndex: 'percentage'},
    {title: 'Valor fijo', dataIndex: 'ammount_fixed'},
    {title: 'Monto inicial', dataIndex: 'amount_initial'},
    {title: 'Balance', dataIndex: 'balance'},
    {title: 'Of. Consec', dataIndex: 'office_consec'},
    {title: 'Of. Consec', dataIndex: 'office_consec_desc'},
    {title: 'Proceso', dataIndex: 'proceso'},
    {title: 'Observaciones', dataIndex: 'observation'}
  ]

  export default {
    data () {
      return {
        fifth_part: null,
        office_consec_vmodel: null,
        office_consec_params: {h_lookup_type: 'AHORRO_CORRIENTE'},
        office_consec: this.$getConfigValue('EMBARGOS_OFFICE_CONSEC_DROPDOWN', 'NO') === 'SI',
        listSN: [
          {name: 'SI', value: '1'},
          {name: 'NO', value: '0'}
        ],
        cod_court: {},
        numberAction: '1',
        loadingBtns: {},
        nombreEntidad: {},
        nombreEntidadSeleccionada: '',
        tipo_demandante: {
          h_lookup_type: 'EMB_DEMANDANT_TYPE'
        },
        tipo_entidad: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        deposito: {
          h_lookup_type: 'EMB_DEPOSIT_CLASS'
        },
        periodos_liquidacion: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        grupo: {
          h_lookup_type: 'GRUPOS_CONCEPTOS_EMBARGOS'
        },
        proceso: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        oficinas: {
          h_lookup_type: 'EMB_OFFICES',
          use_code: true
        },
        status: {
          h_lookup_type: 'ESTADO_EMBARGOS',
          use_code: true
        },
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          endpoint: 'lawsuits',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_lawsuits'
            },
            columns: [
              {title: 'ID embargo', dataIndex: 'id_lawsuits', sorter: true},
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Fecha de embargo', dataIndex: 'lawsuit', sorter: true},
              {title: 'Tipo de embargo', dataIndex: 'tipo_embargo', sorter: true},
              {title: 'ID concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'ID grupo', dataIndex: 'id_groups', sorter: true},
              {title: 'Grupo', dataIndex: 'group_desc', sorter: true}
            ],

            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'A' || record.status === 'P' || (record.status === 'I' &&
                      (this.$userIsInrol('RightHand') || this.$userIsInrol('Management')))) {
                      return true
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'I' && ((this.$userIsInrol('RightHand') || this.$userIsInrol('Management')))) {
                      return true
                    } else if (record.status === 'A' || record.status === 'P') {
                      return true
                    }
                  }
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_lawsuits] === record.id_lawsuits
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'status'},
            {name: 'date_lawsuit'},
            {name: 'num_file'},
            {name: 'office_consec'},
            {name: 'process_number'},
            {name: 'cod_court'},
            {name: 'id_h_bank'},
            {name: 'id_h_class_dep'},
            {name: 'id_h_office_orig'},
            {name: 'id_h_office_dest'},
            {name: 'account_number'},
            {name: 'id_h_demandant_type'},
            {name: 'id_demandant'},
            {name: 'name_deman'},
            {name: 'last_name1_deman'},
            {name: 'last_name2_deman'},
            {name: 'id_groups'},
            {name: 'id_coc'},
            {name: 'percentage'},
            {name: 'lawsuit_type'},
            {name: 'balance'},
            {name: 'amount_initial'},
            {name: 'prc'},
            {name: 'ammount_fixed'},
            {name: 'observation'}
          ],
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            data.fifth_part = this.fifth_part

            return data
          }
        },
        paramsT: {},
        endpointExcel: 'lawsuits_/downloadExcel',
        fileNameExcel: 'Embargos'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      changeTab (key) {
        this.numberAction = key
      },
      handleOk (item) {
        if (JsUtils.isEmpty(item.id_emp) || JsUtils.isEmpty(item.date_lawsuit) || JsUtils.isEmpty(item.lawsuit_type) ||
          JsUtils.isEmpty(item.id_groups) ||
          JsUtils.isEmpty(item.id_coc) || JsUtils.isEmpty(item.prc)) {
          this.numberAction = '1'
        }
      },
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
          case 'masterEdit':
            this.$nextTick(() => {
              this.fifth_part = action.record.fifth_part
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_h_office_orig)) {
                this.$refs.oforigen && this.$refs.oforigen.handleSearch(action.record.id_h_office_orig)
              }
              if (!JsUtils.isEmpty(action.record.id_h_office_dest)) {
                this.$refs.ofdestino && this.$refs.ofdestino.handleSearch(action.record.id_h_office_dest)
              }
              if (!JsUtils.isEmpty(action.record.cod_court)) {
                this.$refs.juzgado && this.$refs.juzgado.handleSearch(action.record.cod_court)
              }
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
              }
            })
            break
        }
      },
      validatePercentage (rule, value, callbackFn) {
        if (value > 10 || value < 0) {
          callbackFn('El porcentaje debe ser de un solo dígito y mayor a 0.')
          return false
        } else {
          return true
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_lawsuits] = record.id_lawsuits
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('lawsuits/download', {
          id_lawsuits: record.id_lawsuits
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_lawsuits]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      detalleEmbargo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns.concat(NEW_COLUMNS)}
      }
    },
    watch: {
      cod_court () {
        this.$refs.master.modal.form.setFieldsValue({
          id_h_office_dest: this.cod_court.office_code
        })
        this.$refs.ofdestino && this.$refs.ofdestino.handleSearch(this.cod_court.office_code)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Lawsuits.vue